import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";
import AirlineSeatReclineExtraIcon from "@material-ui/icons/AirlineSeatReclineExtra";
import OndemandVideoIcon from "@material-ui/icons/OndemandVideo";
import WifiIcon from "@material-ui/icons/Wifi";
import WifiOffIcon from "@material-ui/icons/WifiOff";
import CloseIcon from "@material-ui/icons/Close";
import axios from "axios";

import faresData from "../../fares.json";
import classes from "./SegmentDetails.module.css";

export default function SegmentDetails({ segment, ...props }) {
  const [extraInfo, setExtraInfo] = useState(null);
  const [loadingExtraInfo, setLoadingExtraInfo] = useState(false);

  // useEffect(() => {
  //   getExtraInfo();
  // }, []);

  function formatTime(time) {
    return time < 10 ? `0${time}` : `${time}`;
  }
  function getTimeFormatted(timeString) {
    const time = new Date(timeString);
    const hrs = formatTime(time.getHours());
    const min = formatTime(time.getMinutes());
    return `${hrs}:${min}`;
  }

  function getDurationString(start, end) {
    const startTime = new Date(start);
    const endTime = new Date(end);
    let durationInMilisec = endTime - startTime;
    const durationHr = Math.floor(durationInMilisec / 3600000);
    durationInMilisec %= 3600000;
    const durationMin = durationInMilisec / 60000;
    return `${durationHr > 0 ? `${durationHr} h` : ""} ${durationMin} m`;
  }

  async function getExtraInfo() {
    setLoadingExtraInfo(true);
    let body = {
      query:
        "query FlightDetailQuery(\n  $carrier: ID!\n  $code: String!\n  $outboundDepartureDate: DateTime!\n  $source: ID!\n  $destination: ID!\n  $cabinClass: CabinClassType!\n) {\n  seatInfo(carrier: $carrier, code: $code, outboundDepartureDate: $outboundDepartureDate, source: $source, destination: $destination, cabinClass: $cabinClass) {\n    __typename\n    ... on AppError {\n      error: message\n    }\n    ... on SeatInfo {\n      pitch {\n        value\n        unit\n      }\n      width {\n        value\n        unit\n      }\n      recline {\n        value\n        unit\n      }\n      hasWifi\n      powerAvailable\n      audioVideoAvailable\n    }\n  }\n}\n",
      variables: {
        carrier: segment.operating_carrier
          ? segment.operating_carrier
          : segment.airline,
        code: segment.flight_no + "",
        outboundDepartureDate: new Date(segment.utc_departure)
          .toISOString()
          .split(".")[0],
        source: segment.flyFrom,
        destination: segment.flyTo,
        cabinClass: faresData[segment.fare_category].toUpperCase(),
      },
    };
    let response = await axios.post(
      "https://api.skypicker.com/umbrella/v2/graphql?featureName=FlightDetailQuery",
      body
    );
    if (response && response.data && response.data.data) {
      setExtraInfo(response.data.data.seatInfo);
    }
    setLoadingExtraInfo(false);
  }

  return (
    <>
      <div className={classes["segment-details"]}>
        <div className={classes["segment-details2"]}>
          <div className={classes["segment-details__time-range"]}>
            <Typography
              variant="p"
              fontWeight={700}
              className={classes["start-time"]}
            >
              {getTimeFormatted(segment.utc_departure)}
            </Typography>
            <Typography
              variant="p"
              fontWeight={700}
              className={classes["end-time"]}
            >
              {getTimeFormatted(segment.utc_arrival)}
            </Typography>
          </div>
          <div className={classes["segment-details__vline"]}></div>
          <div className={classes["segment-details__detail"]}>
            <Typography fontWeight={700} marginBottom="1rem">
              {segment.cityFrom || segment.flyFrom}
            </Typography>
            <Typography component="p" className={classes.duration}>
              {getDurationString(segment.utc_departure, segment.utc_arrival)}
            </Typography>
            {extraInfo && !loadingExtraInfo && (
              <div className={classes["extra-info"]}>
                <div className={classes["flight-service"]}>
                  <Typography
                    component="p"
                    style={{
                      fontSize: "11px",
                      color: props.dark ? "var(--black)" : "var(--darker)",
                    }}
                  >
                    <AirlineSeatReclineExtraIcon
                      style={{ fontSize: "20px", marginRight: "0.5rem" }}
                    />
                    {"Seat Pitch: " +
                      extraInfo?.pitch?.value +
                      extraInfo?.pitch?.unit.toLowerCase()}
                  </Typography>
                </div>
                <div className={classes["flight-service"]}>
                  <Typography
                    component="p"
                    style={{
                      fontSize: "11px",
                      color: props.dark ? "var(--black)" : "var(--darker)",
                    }}
                  >
                    <AirlineSeatReclineExtraIcon
                      style={{ fontSize: "20px", marginRight: "0.5rem" }}
                    />
                    {"Seat Width: " +
                      extraInfo?.width?.value +
                      extraInfo?.width?.unit.toLowerCase()}
                  </Typography>
                </div>
                <div className={classes["flight-service"]}>
                  <Typography
                    component="p"
                    style={{
                      fontSize: "11px",
                      color: props.dark ? "var(--black)" : "var(--darker)",
                    }}
                  >
                    <AirlineSeatReclineExtraIcon
                      style={{ fontSize: "20px", marginRight: "0.5rem" }}
                    />
                    {"Seat Recline: " +
                      extraInfo?.recline?.value +
                      extraInfo?.recline?.unit.toLowerCase()}
                  </Typography>
                </div>
                <div className={classes["flight-service"]}>
                  <Typography
                    component="p"
                    style={{
                      fontSize: "11px",
                      color: props.dark ? "var(--black)" : "var(--darker)",
                    }}
                  >
                    <OndemandVideoIcon
                      style={{ fontSize: "20px", marginRight: "0.5rem" }}
                    />
                    Audio & Video on demand -
                    {extraInfo?.audioVideoAvailable ? " Yes" : " No"}
                  </Typography>
                </div>
                <div className={classes["flight-service"]}>
                  <Typography
                    component="p"
                    style={{
                      fontSize: "11px",
                      color: props.dark ? "var(--black)" : "var(--darker)",
                    }}
                  >
                    {extraInfo?.hasWifi ? (
                      <WifiIcon
                        style={{ fontSize: "20px", marginRight: "0.5rem" }}
                      />
                    ) : (
                      <WifiOffIcon
                        style={{ fontSize: "20px", marginRight: "0.5rem" }}
                      />
                    )}
                    &nbsp;{`Wi-Fi on Board`}
                  </Typography>
                </div>
              </div>
            )}
            <Typography fontWeight={700} marginTop="1rem">
              {segment.cityTo || segment.flyTo}
            </Typography>
          </div>
        </div>
        <div className={classes["segment-details__flight-detail"]}>
          <img
            width="40px"
            height="40px"
            src={`https://images.kiwi.com/airlines/64/${
              segment.operating_carrier || segment.airline
            }.png`}
            alt="airline"
          />
          <Typography>
            {segment.operating_carrier || segment.airline} {segment.flight_no}
          </Typography>
          <Typography>
            {faresData[segment.fare_category].toUpperCase()}
          </Typography>
        </div>
      </div>
    </>
  );
}
